import Vue from 'vue';
import confirm from './confirm.vue';
let confirmConstructor = Vue.extend(confirm);
let theConfirm = function (content) {
    return new Promise((res, rej) => {
        //返回promise，ok执行resolve,调用时使用.then继续，no执行reject调用时使用catch捕捉
        let confirmDom = new confirmConstructor({
            el: document.createElement('div')
        })
        const elDiv = document.body.appendChild(confirmDom.$el); //new一个对象，然后插入body里面
        confirmDom.content = content; //为了使confirm的扩展性更强，这个采用对象的方式传入，所有的字段都可以根据需求自定义
        confirmDom.ok = function () {
            res()
            close()
        }
        confirmDom.close = function (err) {
            rej(err)
            close()
        }
        function close() {
            confirmDom.dialogVisible = false
            setTimeout(() => {
                elDiv.remove()
            }, 1000);
        }
    })
}
export default theConfirm;